import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";

export const TableHeader = forwardRef<
  HTMLTableSectionElement,
  React.HTMLAttributes<HTMLTableSectionElement>
>(({ className, ...props }, ref) => (
  <thead
    ref={ref}
    className={twMerge("bg-neutral-20 [&_tr:last-child]:border-0", className)}
    {...props}
  />
));
TableHeader.displayName = "TableHeader";
